import { SvgIconTypeMap } from '@mui/material/SvgIcon'
import { FasDataStats } from './utils'

export enum FasDataItemPlanningStatus {
  Unplanned,
  Planned,
  Completed,
}

export type FasDataSchema = {
  category: number
  function: string
  title: string
  messageType: string
  level: string
  hightestLevel: string
  reason: string
  consequence: string
  geography: string
  plannedStart?: Date
  plannedEnd?: Date
  realEnd?: Date
  occured?: Date
  nextStatus?: Date
  estimateResolved?: Date
  realResolved?: Date
  updated?: Date
  contactName: string
  contactNumber: string
  fasId: string
  status: string
  language: string
}

export type FasDataItemBase = FasDataSchema & {
  geographyFlag: number
}

export type FasDataItem =
  | (FasDataItemBase & {
      planningStatus: FasDataItemPlanningStatus.Unplanned
    })
  | (FasDataItemBase & {
      planningStatus: FasDataItemPlanningStatus.Planned
    })
  | (FasDataItemBase & {
      planningStatus: FasDataItemPlanningStatus.Completed
      wasPlanned: boolean
    })

export type FasData = {
  readonly all: FasDataItem[]
  readonly stats: FasDataStats
}

export type FasDataStatsEntry = {
  [S in FasDataItemPlanningStatus]: number
} & {
  total: number
}

export type Branded<K, T> = K & { __brand?: T }

export type NormalizedSearchWords = Branded<readonly string[], 'NormalizedSearchWords'>

export type StatusIndicators = {
  [key in FasDataItemPlanningStatus]: {
    icon: SvgIconTypeMap['defaultComponent']
    color: SvgIconTypeMap['props']['color']
  }
}
